import {Component, Input} from '@angular/core';
import {EventItem, League, Race} from "@model";
import {DatePipe} from "@angular/common";
import {AbstractComponent} from "../abstract.component";

@Component({
    selector: 'app-page-header-public',
    templateUrl: './page-header-public.component.html',
    styleUrls: ['./page-header-public.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class PageHeaderPublicComponent extends AbstractComponent {
  @Input() currentItem?: EventItem | League;
  @Input() currentRace?: Race | undefined;
  @Input() showLogo?: boolean = true;
  @Input() showDateBadge?: boolean = true;
  @Input() showLinearGradient?: boolean = true;

  constructor(private datePipe: DatePipe) {
    super();
  }

  formatDate(date: Date | string): string {
    const month: string | null = this.datePipe.transform(date, 'MMM');
    return month ? month.slice(0, 3) : '';
  }

  getBackgroundImage() {
    let imageUrl = '../../../assets/img/event-bck.png';

    if (this.currentItem) {
      if ('imageMedium' in this.currentItem) {
        imageUrl = this.currentItem.imageMedium || imageUrl;
      } else if ('image' in this.currentItem) {
        imageUrl = this.currentItem.image || imageUrl;
      }
    }

    if (this.showLinearGradient) {
      return `linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 70%), url('${imageUrl}')`;
    } else {
      return `url('${imageUrl}')`;
    }
  }
}
